/*
 * Copyright (c) 2017 by Julian Feder, julian.feder@yahoo.de
 *
 * This product includes software developed at
 * The Apache Software Foundation (http://www.apache.org/).
 */

(function() {
    'use strict';
    angular
        .module('askApp')
        .factory('ActivitiesMember', ActivitiesMember);

    ActivitiesMember.$inject = ['$resource'];

    function ActivitiesMember ($resource) {
        var resourceUrl =  'api/member/activities/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true}
        });
    }
})();
